import { SerialSearchExpression } from 'src/app/shared/search-expression/serial-search-expression.model';

export class CertificationOptionsModel extends SerialSearchExpression {
  CertificationType: number;
  CeuCreditType: number;
  SearchExpressions: Array<SerialSearchExpression> = [];
  public constructor() {
    super();
  }
}
